export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        autocomplete: {
            type: Boolean,
        },
        autofocus: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
        },
        form: {
            type: String,
        },
        id: {
            type: [Number, String],
            required: true,
        },
        maxlength: {
            type: [Number, String],
        },
        name: {
            type: String,
            required: true,
        },
        readonly: {
            type: Boolean,
        },
        refreshFields: {
            type: Number,
        },
        required: {
            type: Boolean,
        },
        tabindex: {
            type: [Number, String],
        },
        value: {
            type: [String, Number],
        },
        focus: {
            default: false,
            type: Boolean,
        },
    },

    /**
     * Set the data property
     *
     * @return  {object}
     */
    data() {
        return {
            // Set the initial localValue to the value of 'value' prop
            localValue: this.value,
            // Set the initial field type
            type: 'password',
        };
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        /**
         * Emits a change event with a payload consting of input value and the event object
         *
         * @param   {event}  event
         * @return  {void}
         */
        onChange: function (event) {
            this.localValue = event.target.value;

            this.$emit('change', {
                value: event.target.value,
                id: event.target.id,
                name: event.target.name,
                event,
            });
        },

        /**
         * Toggles the password visibility
         *
         * @return  {void}
         */
        revealPassword: function () {
            this.type = this.type === 'password' ? 'text' : 'password';
        },
    },

    /**
     * Component's computed property
     *
     * @type  {Object}
     */
    computed: {
        lockIcon() {
            return {
                'fa-lock': this.type === 'password',
                'fa-unlock': this.type === 'text',
            };
        },
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.$nextTick(() => {
            if (this.focus) {
                $(this.$el).find(`#${this.id}`).focus();
            }
        });
    },

    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                this.$forceUpdate();

                this.localValue = this.value;

                this.type = 'password';

                if (this.focus) {
                    $(this.$el).find(`#${this.id}`).focus();
                }
            }
        },
    },
};
